var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6645_2925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5937 15.0625H7.43127C6.65465 15.0625 6.02502 15.6922 6.02502 16.4688V46.5938C6.02502 47.3704 6.65465 48 7.43127 48H46.5937C47.3704 48 48 47.3704 48 46.5938V16.4688C48 15.6922 47.3704 15.0625 46.5937 15.0625Z",
    fill: "#464E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5938 15.0625H26.9125V48H46.5938C47.3704 48 48 47.3704 48 46.5938V16.4688C48 15.6922 47.3704 15.0625 46.5938 15.0625Z",
    fill: "#0D1146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5063 26.9124H1.40625C0.629625 26.9124 0 26.2828 0 25.5062V1.40625C0 0.629625 0.629625 0 1.40625 0H25.5063C26.2829 0 26.9125 0.629625 26.9125 1.40625V25.5062C26.9125 26.2829 26.2829 26.9124 25.5063 26.9124Z",
    fill: "#F0F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9125 25.5062V1.40625C26.9125 0.629625 26.2829 0 25.5063 0H13.4562V26.9124H25.5063C26.2829 26.9124 26.9125 26.2829 26.9125 25.5062Z",
    fill: "#D0E3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4562 21.6406C11.27 21.6406 9.21471 20.7892 7.66896 19.2435C7.11987 18.6943 7.11987 17.804 7.66896 17.2548L12.4618 12.4619C12.7256 12.1982 13.0832 12.05 13.4561 12.05H20.2343C21.0109 12.05 21.6405 12.6796 21.6405 13.4562C21.6406 17.9691 17.9692 21.6406 13.4562 21.6406Z",
    fill: "#FF5B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 13.4562C21.6406 12.6796 21.011 12.05 20.2344 12.05H13.4562V21.6406C17.9692 21.6406 21.6406 17.9691 21.6406 13.4562Z",
    fill: "#F53176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8625 12.05V6.6781C14.8625 5.90148 14.2329 5.27185 13.4562 5.27185C8.94338 5.27185 5.27185 8.94329 5.27185 13.4562C5.27185 15.6423 6.12319 17.6976 7.66894 19.2434L14.8625 12.05Z",
    fill: "#13F8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4562 13.4562V5.27185C17.9692 5.27185 21.6406 8.94329 21.6406 13.4562H13.4562Z",
    fill: "#5086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 41.975H21.9312C22.7597 41.975 23.4312 41.3035 23.4312 40.475V34.6375C23.4312 33.809 22.7597 33.1375 21.9312 33.1375H13.55C12.7215 33.1375 12.05 33.809 12.05 34.6375V40.475C12.05 41.3035 12.7216 41.975 13.55 41.975Z",
    fill: "#13F8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.025 41.975H31.9062C32.7347 41.975 33.4062 41.3034 33.4062 40.475V31.625C33.4062 30.7965 32.7347 30.125 31.9062 30.125H23.525C22.6965 30.125 22.025 30.7965 22.025 31.625V41.975Z",
    fill: "#FF5B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9062 30.125H26.9125V41.975H31.9062C32.7347 41.975 33.4062 41.3033 33.4062 40.475V31.625C33.4062 30.7965 32.7347 30.125 31.9062 30.125Z",
    fill: "#F53176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 41.975H40.475C41.3035 41.975 41.975 41.3034 41.975 40.475V22.5875C41.975 21.759 41.3035 21.0875 40.475 21.0875H33.5C32.6715 21.0875 32 21.759 32 22.5875V41.975Z",
    fill: "#5086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6437 0C32.2247 0 30.225 1.95478 30.225 4.41872V10.4438C30.225 11.2204 30.8546 11.85 31.6312 11.85C32.4079 11.85 33.0375 11.2204 33.0375 10.4438V8.83753H36.25V10.4438C36.25 11.2204 36.8796 11.85 37.6563 11.85C38.4329 11.85 39.0625 11.2204 39.0625 10.4438V4.41872C39.0625 2.00428 37.112 0 34.6437 0ZM36.25 6.02503H33.0375V4.41872C33.0375 3.53391 33.7535 2.8125 34.6437 2.8125C35.5306 2.8125 36.2499 3.53044 36.2499 4.41872V6.02503H36.25Z",
    fill: "#0D1146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5937 9.0375H45.7406V2.8125H46.5937C47.3703 2.8125 48 2.18288 48 1.40625C48 0.629625 47.3703 0 46.5937 0H42.075C41.2983 0 40.6687 0.629625 40.6687 1.40625C40.6687 2.18288 41.2983 2.8125 42.075 2.8125H42.9281V9.0375H42.075C41.2983 9.0375 40.6687 9.66712 40.6687 10.4438C40.6687 11.2204 41.2983 11.85 42.075 11.85H46.5937C47.3703 11.85 48 11.2204 48 10.4438C48 9.66712 47.3703 9.0375 46.5937 9.0375Z",
    fill: "#0D1146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6645_2925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisIcon);
export default __webpack_public_path__ + "static/media/analysisIcon.5205197d9a0d9c5e35eda1466490320e.svg";
export { ForwardRef as ReactComponent };